import Page from '@inspire/ui/chakra/layout/Page';

import Layout from 'components/layout/Layout';
import PrivacyPolicyContent from 'components/legal/PrivacyPolicyContent';

const ConfidentialitePage = () => (
  <Page title="Politique de confidentialité" withPanel headingIsTitle>
    <PrivacyPolicyContent />
  </Page>
);

ConfidentialitePage.getWrappers = (page) => (
  <Layout
    variant="adaptative"
    rowProps={{ variant: 'gray' }}
    containerWidth="lg"
  >
    {page}
  </Layout>
);

export default ConfidentialitePage;
